import {slideToggle, slideUp, index} from '../utility/utils';
import { smoother } from '../utility/gsap';

function toggleAccordion(e){
  e.preventDefault();

  if(e.type === 'click' || e.key === 'Enter' ){
    // If using GSAP ScrollSmoother, prevent it from causing 
    // stuttering while accordion triggers resize events
    if(smoother){
      document.body.classList.add('prevent-smoother-update');
      
      if(window.accordion.smootherUpdateTimeout){
        clearTimeout(window.accordion.smootherUpdateTimeout);
      }

      window.accordion.smootherUpdateTimeout = setTimeout(() => {
        document.body.classList.remove('prevent-smoother-update');
        window.accordion.smootherUpdateTimeout = null;
      }, 500);
    }

    const el = e.target;
    const target = el.nextElementSibling;
    const accordion_item = el.closest('.accordion__item');

    if(!target){
      return;
    }

    const scrollPos = window.pageYOffset | document.body.scrollTop;
    let elTopPos = accordion_item.getBoundingClientRect().top + scrollPos;
    let topOffset = 0;

    // Close any open items within accordion list that isn't this element
    const accordionList = target.closest('.accordion__list');

    if(accordionList){
      const activeListItem = accordionList.querySelector('.accordion__item.active');
      if(activeListItem && activeListItem !== accordion_item){
        const activeTrigger = activeListItem.querySelector('.accordion__trigger');
        const activeContent = activeListItem.querySelector('.accordion__content');

        activeListItem.classList.remove('active');
        activeTrigger.classList.remove('active');
        activeContent.classList.remove('active');

        // If the previously active item is above the new accordion item, alter the elTopPos variable
        const activeIndex   = index(activeListItem);
        const clickedIndex  = index(accordion_item);
        if(activeIndex < clickedIndex){
          topOffset = activeContent.offsetHeight;
        }

        activeContent.setAttribute('aria-hidden', 'true');
        slideUp(activeContent);
      }
    }

    // Toggle active class
    accordion_item.classList.toggle('active');
    el.classList.toggle('active');
    target.classList.toggle('active');

    // Toggle Aria-Hidden attribute
    const aria_hidden = target.classList.contains('active') ? 'false' : 'true';
    target.setAttribute('aria-hidden', aria_hidden);

    // Toggle Content Height
    slideToggle(target);

    // Slide window to active item position if it has gone outside of the screen
    const adminBarEl = document.getElementById("wpadminbar");
    const adminBarHeight = adminBarEl ? adminBarEl.offsetHeight : 0;
    if(topOffset !== 0 && (elTopPos - topOffset) < (scrollPos + adminBarHeight)){
      document
      elTopPos = elTopPos - adminBarHeight - 20 - topOffset;
      document.body.classList.add('preventHeaderReveal');
      
      if(smoother){
        smoother.scrollTo(elTopPos, true, "top");
      }
      else {
        scroll({
          top: elTopPos,
          behavior: "smooth",
        });
      }
        
      setTimeout(() => {
        document.body.classList.remove('preventHeaderReveal');
      }, 600);
    }
  }
}


export const initializeAccordions = (event) => {
  // Helper object to store accordion state data while opening/closing
  window.accordion = window.accordion || {};

  // Accordion Toggle
  const accordions = document.querySelectorAll('.accordion__trigger');
  accordions.forEach(item => {
    item.addEventListener('click', toggleAccordion);
    item.addEventListener('keypress', toggleAccordion);
  });
};


